import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d6035d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
      /*#__PURE__*/_createElementVNode("h1", null, "Scheduling")
    ])
  ])
], -1))
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No schedules found", -1))
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "schedule-header" }
const _hoisted_6 = { class: "table table-bordered table-sm" }
const _hoisted_7 = {
  width: "17.7%",
  class: "align-middle"
}
const _hoisted_8 = { width: "3.3%" }
const _hoisted_9 = ["value", "onSelect"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "timing-cell"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "3.3%" }, null, -1))
const _hoisted_59 = {
  key: 0,
  class: "sliderrow"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "slidercol" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_62 = ["colspan"]
const _hoisted_63 = ["colspan"]

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { Schedule, ReportTiming, TimingGroup, Inspector } from '@/models';
import defaultschedules from "@/store/inspectors/json/schedules.json";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import moment from 'moment';
import { useEvent } from '@/eventBus';


export default /*#__PURE__*/_defineComponent({
  __name: 'Scheduling',
  setup(__props) {

const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const inspector = computed(() => store.getters['inspectors/current']);

const store = useStore();
const setInspectorDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('inspectors/setInspectorDeep', payload);
};
const getSliderWidth = (minutes: number) => {
  let width = 0;
  if (minutes >= 15) {
    width = minutes / 15;
  }
  return width;
};

const primaryColors = ref<string[]>([
    "#E51A51",
    "#1AE5AE",
    "#7A0FF0",
    "#85F00F",
    "#6251AE",
    "#9DAE51",
    "#1858E7",
    "#E7A718",
    "#4192BE",
    "#BE6D41",
    "#05E1FA",
    "#FA1E05",
    "#E0BF1F",
    "#1F40E0",
    "#B2F302",
    "#214FC6",
    "#FF8866",
    "#CEC8EF",
    "#FF5050",
]);


onMounted(() => {
  useEvent("inspectorLoadedOnSchedulingPage", (insp: Inspector) => {
    if (!inspector.value.schedules || inspector.value.schedules.length === 0) {
      inspector.value.schedules = defaultschedules.schedules.map(
        (s: any) => new Schedule(s)
      );
    }
  });
});

const getBackgroundColor = (
  schedule: Schedule,
  timingGroup: TimingGroup,
  reportTiming: ReportTiming,
  minutes: number
) => {
  let color = '#ffffff';
  const scheduleIndex = inspector.value.schedules.findIndex(
    (s) => s.reporttype === schedule.reporttype
  );
  if (scheduleIndex >= 0) {
    const timingIndex = timingGroup.propertytypegroup.findIndex(
      (t) => t.propertytype === reportTiming.propertytype
    );
    if (timingIndex >= 0 && minutes <= reportTiming.timing) {
      color =
        timingIndex % 2 === 0
          ? primaryColors.value[scheduleIndex]
          : primaryColors.value[scheduleIndex] + '55';
    }
  }
  return color;
};

const minutesToTime = (minutes: number) => {
  const format = new Date(minutes * 60 * 1000).toISOString().substr(11, 5);
  return format;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (!inspector.value.schedules.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, "for " + _toDisplayString(inspector.value.name) + ", please add", 1)
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(inspector.value.schedules, (schedule, $scheduleindex) => {
          return (_openBlock(), _createElementBlock("div", { key: $scheduleindex }, [
            _createElementVNode("header", null, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(schedule.reporttype), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule.timinggroups, (timinggroup, $timinggroupindex) => {
              return (_openBlock(), _createElementBlock("div", { key: $timinggroupindex }, [
                _createElementVNode("table", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timinggroup.propertytypegroup, (reporttiming, $reporttimingindex) => {
                    return (_openBlock(), _createElementBlock("tbody", { key: $reporttimingindex }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_7, _toDisplayString(reporttiming.propertytype), 1),
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("input", {
                            value: reporttiming.minutesperitem,
                            min: "0",
                            type: "number",
                            class: "minutesperitem",
                            onSelect: ($event: any) => (setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].minutesperitem`,
                    data: $event.target.value,
                  }))
                          }, null, 40, _hoisted_9)
                        ]),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 15,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    15
                  ),
                })
                        }, [
                          (reporttiming.timing === 15)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 0:15 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_10),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 30,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    30
                  ),
                })
                        }, [
                          (reporttiming.timing === 30)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 0:30 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_12),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 45,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    45
                  ),
                })
                        }, [
                          (reporttiming.timing === 45)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 0:45 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_14),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 60,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    60
                  ),
                })
                        }, [
                          (reporttiming.timing === 60)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 1:00 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_16),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 75,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    75
                  ),
                })
                        }, [
                          (reporttiming.timing === 75)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 1:15 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_18),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 90,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    90
                  ),
                })
                        }, [
                          (reporttiming.timing === 90)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 1:30 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_20),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 105,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    105
                  ),
                })
                        }, [
                          (reporttiming.timing === 105)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 1:45 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_22),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 120,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    120
                  ),
                })
                        }, [
                          (reporttiming.timing === 120)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, " 2:00 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_24),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 135,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    135
                  ),
                })
                        }, [
                          (reporttiming.timing === 135)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 2:15 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_26),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 150,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    150
                  ),
                })
                        }, [
                          (reporttiming.timing === 150)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, " 2:30 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_28),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 165,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    165
                  ),
                })
                        }, [
                          (reporttiming.timing === 165)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, " 2:45 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_30),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 180,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    180
                  ),
                })
                        }, [
                          (reporttiming.timing === 180)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, " 3:00 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_32),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 195,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    195
                  ),
                })
                        }, [
                          (reporttiming.timing === 195)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 3:15 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_34),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 210,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    210
                  ),
                })
                        }, [
                          (reporttiming.timing === 210)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 3:30 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_36),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 225,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    225
                  ),
                })
                        }, [
                          (reporttiming.timing === 225)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, " 3:45 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_38),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 240,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    240
                  ),
                })
                        }, [
                          (reporttiming.timing === 240)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, " 4:00 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_40),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 255,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    255
                  ),
                })
                        }, [
                          (reporttiming.timing === 255)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, " 4:15 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_42),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 270,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    270
                  ),
                })
                        }, [
                          (reporttiming.timing === 270)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, " 4:30 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_44),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 285,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    285
                  ),
                })
                        }, [
                          (reporttiming.timing === 285)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, " 4:45 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_46),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 300,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    300
                  ),
                })
                        }, [
                          (reporttiming.timing === 300)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, " 5:00 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_48),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 315,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    315
                  ),
                })
                        }, [
                          (reporttiming.timing === 315)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, " 5:15 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_50),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 330,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    330
                  ),
                })
                        }, [
                          (reporttiming.timing === 330)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, " 5:30 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_52),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 345,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    345
                  ),
                })
                        }, [
                          (reporttiming.timing === 345)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, " 5:45 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_54),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                  setInspectorDeep({
                    path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].timing`,
                    data: 360,
                  })
                ),
                          width: "3.3%",
                          style: _normalizeStyle({
                  'background-color': getBackgroundColor(
                    schedule,
                    timinggroup,
                    reporttiming,
                    360
                  ),
                })
                        }, [
                          (reporttiming.timing === 360)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, " 6:00 "))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_56),
                        _hoisted_58
                      ]),
                      (!schedule.reporttype.startsWith('Check-Out') && !schedule.reporttype.startsWith('Schedule of Condition'))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_59, [
                            _hoisted_60,
                            _hoisted_61,
                            _createElementVNode("td", {
                              colspan: getSliderWidth(reporttiming.timing),
                              class: "slidercol"
                            }, [
                              _createVNode(_unref(VueSlider), {
                                modelValue: reporttiming.tenanttoarriveafter,
                                "onUpdate:modelValue": ($event: any) => ((reporttiming.tenanttoarriveafter) = $event),
                                min: 0,
                                max: reporttiming.timing,
                                interval: 15,
                                "tooltip-formatter": (val) => minutesToTime(val),
                                direction: "rtl",
                                processStyle: {
                    'background-color': getBackgroundColor(
                      schedule,
                      timinggroup,
                      reporttiming,
                      0
                    ),
                  },
                                onChange: 
                    (value) =>
                      setInspectorDeep({
                        path: `schedules[${$scheduleindex}].timinggroups[${$timinggroupindex}].propertytypegroup[${$reporttimingindex}].tenanttoarriveafter`,
                        data: value,
                      })
                  
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "tooltip-formatter", "processStyle", "onChange"])
                            ], 8, _hoisted_62),
                            _createElementVNode("td", {
                              colspan: 24 - getSliderWidth(reporttiming.timing),
                              style: {"white-space":"nowrap"}
                            }, _toDisplayString(minutesToTime(reporttiming.tenanttoarriveafter)) + " minutes prior to end of inspection ", 9, _hoisted_63)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
        }), 128))
  ]))
}
}

})